import { render } from "./Recepciones.vue?vue&type=template&id=37d94e9c"
import script from "./Recepciones.vue?vue&type=script&lang=js"
export * from "./Recepciones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__